import Quill from 'quill';

import * as formats from '.';

Object.keys(formats).forEach((formatName) => {
  const format = formats[formatName];

  Quill.register(
    {
      [`formats/${format.blotName}`]: format,
    },
    true,
  );
});
